<template>
  <div v-if="data" class="relative h-full pb-4 overflow-x-auto bg-white">
    <table class="w-full text-sm text-left text-gray-900 divide-y divide-gray-200">
      <BaseDetailsTableRow
        :name="$t('pricing.pricingPolicy')"
        :mode="mode"
        :isHorizontalLayout="isHorizontalLayout">
        <BaseSelectDropdown
          :items="dropdownPricingPolicies"
          :selected-item="selectedPricingPolicy"
          name="pricingPolicies"
          flat
          clearable
          :mode="mode"
          @update:selected="handlePricingPolicySelection" />
      </BaseDetailsTableRow>

      <BaseDetailsTableRow
        :name="$t('baseObject.code')"
        :mode="mode"
        :isHorizontalLayout="isHorizontalLayout">
        {{ selectedPricingPolicy?.code || '-' }}
      </BaseDetailsTableRow>
      <BaseDetailsTableRow
        :name="$t('pricing.pricingType')"
        :mode="mode"
        :isHorizontalLayout="isHorizontalLayout">
        {{ selectedPricingPolicy?.pricingType || '-' }}
      </BaseDetailsTableRow>
    </table>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { type Customer } from '@/types/Traders';
import { getPricingPolicyCatalogsOrder, getPricingPolicyMatrices } from '@/services/api/prices';

import BaseDetailsTableRow from '../common/BaseDetailsTableRow.vue';
import BaseSelectDropdown from '../common/BaseSelectDropdown.vue';
import type { SelectDropdownItem } from '@/types/Base';
const data = defineModel<Customer>();
defineProps<{
  mode: 'view' | 'edit';
  isHorizontalLayout: boolean;
}>();

const dropdownPricingPolicies = ref<(SelectDropdownItem & { code: string; pricingType: string })[]>(
  []
);
const selectedPricingPolicy = ref<
  (SelectDropdownItem & { code: string; pricingType: string }) | null
>(null);
onMounted(async () => {
  const orders = await getPricingPolicyCatalogsOrder();
  const matrices = await getPricingPolicyMatrices();

  if (orders)
    dropdownPricingPolicies.value = orders.map((x) => ({
      value: x.pricingPolicyId,
      name: x.name,
      code: x.code,
      pricingType: 'Price List',
    }));

  if (matrices) {
    dropdownPricingPolicies.value = dropdownPricingPolicies.value.concat(
      matrices.map((x) => ({
        value: x.pricingPolicyId,
        name: x.name,
        code: x.code,
        pricingType: 'Discount',
      }))
    );
  }
  if (data.value?.pricingPolicyId) {
    selectedPricingPolicy.value =
      dropdownPricingPolicies.value.find((x) => x.value === data.value?.pricingPolicyId) || null;
  }
});

function handlePricingPolicySelection(
  item: SelectDropdownItem & { code: string; pricingType: string }
) {
  selectedPricingPolicy.value = item;
  if (data.value && item) data.value.pricingPolicyId = item.value as string;
}
</script>
